import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useAppDispatch, useTypedSelector } from 'store/index';
import { preCheck, showAppAuth } from 'components/auth';
import { Application, fetchApplicationList, rta } from 'store/application';
import qs from 'qs';
import Tabs from 'components/tabs';
import { Button } from '@tencent/spaui';
import nonStandardAuth from 'common/nonStandardAuth';
import AddApp from 'components/appBindinng/BindApp';
import { post } from 'store/request';

const tabs = ['投放提效', '私域运营', 'RTA投放'];

interface query {
  from?: string;
  client_id?: string;
}

interface appProps {
  app: Application;
  pending: string;
  handleAuth: (id: string) => void;
  showAuthCount?: boolean;
  query?: query;
}

const ApplicationItem = (props: appProps) => {
  const { app, pending, handleAuth, showAuthCount, query } = props;
  const {
    client_id,
    app_icon,
    app_name,
    app_desc,
    app_highlights,
    feedback_data,
    client_auth_count,
    client_bind_status,
  } = app;
  const [hasAdd, setHasAdd] = useState<boolean>(client_bind_status || false);

  return (
    <Link
      className="item application flex-list-item flex-list-application"
      key={client_id}
      to={`/application/${client_id}/?${qs.stringify(query)}`}
      data-track="app-detail"
      data-client-id={client_id}
    >
      <div className="title">
        <img src={app_icon} alt={app_name} />
        <span className="text-bold">{app_name}</span>
      </div>
      {app_desc && <div className="text-desc desc">{app_desc}</div>}
      {feedback_data && <div className="text-desc desc">{feedback_data}</div>}
      {showAuthCount && (
        <div className="text-desc desc">
          累计使用次数：<span className="orange-tag">{client_auth_count}+</span>
        </div>
      )}

      <div className="tag-list">{app_highlights && <div className="text-bold tag">{app_highlights}</div>}</div>
      <div className="btn-group">
        {query && query.from === 'amshomesgj' && !query.client_id && !hasAdd ? (
          <AddApp
            loading={pending === client_id}
            disabled={pending === client_id}
            client_id={client_id}
            onFinish={() => {
              setHasAdd(true);
            }}
          />
        ) : (
          <Button
            loading={pending === client_id}
            disabled={pending === client_id}
            onClick={(e: MouseEvent) => {
              e.preventDefault();
              handleAuth(client_id);
            }}
          >
            <span>{client_id === rta.client_id ? '立即申请' : '立即使用'}</span>
          </Button>
        )}
        <div className="details">
          详情
          <span className="icon icon-arrow-right" />
        </div>
      </div>
    </Link>
  );
};

const Applications: React.FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const {
    user: { myApp },
    application: {
      list,
      touFang,
      touFangList,
      // siYu,
      rta,
    },
  } = useTypedSelector((state) => state);
  const [pending, setPending] = useState<string>();
  const [query, setQuery] = useState({});
  const [siyuNewList, setSiyuNewList] = useState([]);

  const handleAuth = (id: string) => {
    if (id === pending || nonStandardAuth(id, setPending)) {
      return;
    }

    if (preCheck()) {
      const temp = myApp?.find((item) => item.client_id === id);
      if (!temp?.authorize_status) {
        history.push(`/application/${id}/${history.location.search}`);
      } else {
        showAppAuth(id);
      }
    }
  };

  useEffect(() => {
    setQuery(qs.parse(history.location.search, { ignoreQueryPrefix: true }));
  }, [history?.location?.search]);

  useEffect(() => {
    if (!touFang.length) {
      dispatch(fetchApplicationList());
      return;
    }

    if (typeof IntersectionObserver !== 'function') {
      document.querySelectorAll('.fade').forEach((element) => {
        /* eslint-disable-next-line no-param-reassign */
        element.className += ' fade-in';
      });
      return;
    }

    const sectionList = document.querySelectorAll('section');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting !== false && !entry.target.className.includes('fade-in')) {
          entry.target.querySelectorAll('.fade').forEach((element) => {
            if (!element.className.includes('fade-in')) {
              /* eslint-disable-next-line no-param-reassign */
              element.className += ' fade-in';
            }
          });
        }
      });
    });
    sectionList.forEach((section) => observer.observe(section));
    return () => {
      sectionList.forEach((section) => observer.unobserve(section));
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [touFang]);

  // 获取私区运营排序后列表
  useEffect(() => {
    post('/application/list', { category: 1 }, 'v2').then((res) => {
      const list0 = res?.[0]?.filter((item: any) => item.level === 1);
      const list1 = res?.[1]?.filter((item: any) => item.level === 1);
      const list2 = res?.[2]?.filter((item: any) => item.level === 1);
      setSiyuNewList([list0, list1, list2]);
    });
  }, []);

  return (
    <section className="applications">
      <div className="fade text-bold header">广告营销工具</div>
      <div className="fade text-bold sub-header">MARKETING TOOLS</div>

      <div className="fade">
        <Tabs tabs={tabs}>
          <>
            <div className="flex-list">
              {touFangList?.map((id, index) => (
                <ApplicationItem
                  key={index}
                  app={list[id]}
                  pending={pending}
                  handleAuth={handleAuth}
                  showAuthCount={true}
                  query={query}
                />
              ))}
            </div>
          </>

          <>
            <div className="desc-wrapper">
              <div className="text-bold">私域运营</div>
              <div className="text-desc">
                聚焦零售、金融、O2O、婚摄、家居等垂直行业，打造客服、CRM、建站等私域营销工具，形成“广告引流-私域转化”的营销闭环，实现交易的正循环。
              </div>
              <div className="text-desc">
                服务市场的私域运营工具已支持公众号、微信/企业微信、小程序等核心私域流量渠道；所有私域工具均提供免费试用期，试用期间服务商将免费为您提供运营支持。
              </div>
            </div>
            <div className="flex-list column-app-list" style={{ width: '104%' }}>
              {siyuNewList?.map((listGroup, ind) => (
                <div key={ind} style={{ display: 'flex', flexDirection: 'column' }}>
                  {listGroup?.map((item: any, index: number) => (
                    <ApplicationItem key={index} app={item} pending={pending} handleAuth={handleAuth} />
                  ))}
                </div>
              ))}
            </div>
          </>
          <>
            <div className="desc-wrapper">
              <div className="text-bold">RTA (Realtime API)</div>
              <div className="text-desc">
                RTA(Realtime API)在腾讯直投的基础上，帮助客户实现流量的实时优选及个性化用户筛选，让您的买量更加有效。
              </div>
              <div className="text-desc">
                若您具备较强的技术能力且在腾讯日消耗可达5w以上，通过服务市场可直接与腾讯对接，自行搭建定制化RTA工具。同时，您也可选择使用第三方RTA工具，快速上手RTA投放能力。
              </div>
            </div>
            <div className="flex-list column-app-list">
              {rta?.map((id, index) => (
                <ApplicationItem key={index} app={list[id]} pending={pending} handleAuth={handleAuth} />
              ))}
            </div>
          </>
        </Tabs>
      </div>
    </section>
  );
};

export default Applications;
